export default __webpack_public_path__ + "static/media/004-B-soinesthetique.0958a1e1.svg";